module.exports = __webpack_public_path__ + "img/tree.cf5d959e.png";